import { styled } from 'baseui'
import type { Theme } from 'baseui'

interface PulseCopyButtonProps {
  $theme: Theme
  $copied: boolean
  $hasValue: boolean
}

const pulseCopyColor = ({ $theme, $copied, $hasValue }: PulseCopyButtonProps) => {
  if ($copied) return $theme.colors.successPulse
  if (!$hasValue) return $theme.colors.iconPulseFieldIdle
  return $theme.colors.iconPulseField
}

export const PulseCopyButton = styled<'button', { $copied: boolean; $hasValue: boolean }>('button', props => ({
  width: '26px',
  height: '26px',
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  borderTopWidth: 0,
  borderBottomWidth: 0,
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderTopLeftRadius: '6px',
  borderTopRightRadius: '6px',
  borderBottomLeftRadius: '6px',
  borderBottomRightRadius: '6px',
  backgroundColor: 'transparent',
  color: pulseCopyColor(props),
  cursor: props.$hasValue ? 'pointer' : 'default',
  ':hover': props.$hasValue
    ? { backgroundColor: props.$theme.colors.bgPulseFieldIconHover, color: props.$theme.colors.primaryPulse }
    : {},
}))
